interface Adaptation {
  chat_id: string;
  current_filter: 'all_companies' | 'current_company';
  chosen_filter: 'all_companies' | 'current_company';
}

export function livechatTemplatesFilterCompanyChangeAdapter(
  attendanceId: string,
  currentSelectedCompany?: string | undefined,
  chosenCompany?: string | undefined,
): Adaptation {
  const oldFilter = currentSelectedCompany ? 'current_company' : 'all_companies';
  const newFilter = chosenCompany ? 'current_company' : 'all_companies';

  return {
    chat_id: attendanceId,
    current_filter: oldFilter,
    chosen_filter: newFilter,
  }
}
